import { inject, Service } from '@angular/core';

import { _BaasApmService } from '../services/baas-apm.service';
import { BarInitializedHook } from './bar-initialized.hook';

@Service({ autoProvided: false })
/** Hook for setting up Elastic APM. */
export class BaasApmInitHook implements BarInitializedHook {
    readonly #apm = inject(_BaasApmService);

    readonly _framework = true;

    run(): void {
        this.#apm.observe();
    }
}
